<template>
  <div>
    <b-input
      v-model="searchStr"
      label="Знайти документ"
      hide-details
      placeholder="Пошук за назвою, номером, класом..."
      class="mb-3">
      <template #prepend-inner>
        <v-icon icon="mdi-magnify" size="small"></v-icon>
      </template>
    </b-input>

    <v-card border>
      <v-list>
        <v-list-item
          v-if="!documentList.length"
          disabled
          class="text-disabled text-center pa-3">
          Дані відсутні
        </v-list-item>
        <v-list-item
          v-for="document in documentList"
          :key="document.id"
          class="pa-3"
          color="info"
          :active="document.id === relatedDocumentId"
          @click="relatedDocumentId = document.id">
          <div class="d-flex justify-space-between align-center ga-3">
            <div class="d-flex align-center ga-3">
              <div class="icon-wrapper">
                <v-icon color="info" icon="mdi-file-outline"></v-icon>
              </div>

              <div>
                <div
                  :class="{
                    'font-weight-bold': document.id === relatedDocumentId,
                    'text-light-blue-darken-4':
                      document.id === relatedDocumentId,
                  }">
                  {{ document.docTypeClass.name }}
                  {{ document.definition.name }}
                  {{ document.registrationNumber }}
                </div>
                <div class="text-disabled">
                  {{ document.definition.name }}
                  {{ new CustomDate(document.created_at).toString() }}
                </div>
              </div>
            </div>
            <div>
              <v-icon
                v-if="document.id === relatedDocumentId"
                icon="mdi-check"></v-icon>
            </div>
          </div>
        </v-list-item>
      </v-list>
    </v-card>
  </div>
</template>

<script setup lang="ts">
import { ref, shallowRef, watch } from 'vue'
import { Dialog } from '@/dialog'
import { documentRelationCreate } from '@/requests/document'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { documentList as documentListRequest } from '@/requests/document'
import { debounce } from 'lodash'
import { CustomDate } from 'best-modules/utils'

defineOptions({
  name: 'DocumentRelation',
})

const props = defineProps<{
  dialog: Dialog
}>()

const relatedDocumentId = ref<any>(null)

const v$ = useVuelidate(
  {
    relatedDocumentId: { required },
  },
  { relatedDocumentId }
)

const searchStr = ref<string>('')

const documentList = shallowRef<any[]>([])

const getDocumentList = (search: any = null) => {
  return documentListRequest({ page: 1, search }).then(res => {
    relatedDocumentId.value = null
    documentList.value = res.data.filter(d => {
      return (
        d.id !== props.dialog.dialogData.docTypeDocumentId &&
        !props.dialog.dialogData.existRelationDocumentIds.includes(d.id)
      )
    })
  })
}

watch(searchStr, debounce(getDocumentList, 500))

getDocumentList()

const submit = () => {
  return documentRelationCreate({
    docTypeDocumentId: props.dialog.dialogData.docTypeDocumentId,
    relatedDocumentId: relatedDocumentId.value,
  })
}

defineExpose({ submit, v$, relatedDocumentId })
</script>
